import { PortfolioContent } from "./components/portofolio/PortofolioContent";
import Layout from "./components/ui/Layout";

export const Portfolio = () => {
  return (
    <Layout>
      <PortfolioContent />
    </Layout>
  );
};
